import { render, staticRenderFns } from "./OrganizationTickerSettings.vue?vue&type=template&id=f3e06c3c&scoped=true"
import script from "./OrganizationTickerSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationTickerSettings.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTickerSettings.vue?vue&type=style&index=0&id=f3e06c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e06c3c",
  null
  
)

export default component.exports